import { isUndefined } from 'lodash';
import React from 'react';
import FileIcon from '@shared/assets/icons/v2/file.svg';
import { MBText } from '@shared/components/MBText';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBIcon } from '@shared/components/image';
import { MBCircularProgressBar } from '@shared/components/loading';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Colors } from '@shared/styles';
import { MBLinking } from '@shared/util/linking';
import { Styles, UnvalidatedStyles } from './styles';
import { MBChatAttachmentProps } from './index';

/*
    Default attachment preview when in a chat thread. A thin list row containing
    a generic attachment icon and the attachment's name.
*/
export class MBChatAttachmentFallback extends React.PureComponent<MBChatAttachmentProps> {
  onPress = () => {
    MBLinking.open(this.props.attachment.url);
  };

  render() {
    const { attachment, progress, style, isSending } = this.props;

    return (
      <MBTouchableOpacity onPress={this.onPress} style={style}>
        <View row padding={1} centerVertically>
          <MBIcon noPadding size="small" color={Colors.v2.purple} source={FileIcon} />
          <MBText numberOfLines={1}>{attachment.name}</MBText>

          {isSending && !isUndefined(progress) && (
            <MBCircularProgressBar size="small" progress={progress} />
          )}
        </View>
      </MBTouchableOpacity>
    );
  }
}

/*
    Square version of the default attachment preview. Used eg in chat input attachment list.
*/
export function MBChatAttachmentFallbackSquare({ attachment, style }: MBChatAttachmentProps) {
  return (
    <MBView padding={1.25} center style={[style, Styles.square]}>
      <MBIcon size="large" noPadding color={Colors.v2.purple} source={FileIcon} />
      <MBText center style={UnvalidatedStyles.fallbackFileNameText as any}>
        {attachment.name}
      </MBText>
    </MBView>
  );
}
